import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode } from "vue"

import request from "../../common/request";
import { useRouter } from "vue-router";
import { computed, onMounted } from "vue";
import { ref, reactive, watch } from "vue";
import type { UploadProps } from "ant-design-vue";
import { v4 as uuidv4 } from "uuid";
import { message } from "ant-design-vue";
import { operateLogs } from "@/common/logs";
import { getLanguage } from "@/common/translate";

export default /*@__PURE__*/_defineComponent({
  __name: 'digitizerMonitor',
  setup(__props) {

const router = useRouter();
const loading = ref(false);
/**操作日志记录 */
operateLogs("Access edge gateway management");
/**操作日志记录 */

let dataList:any = ref([])
const columns = [
{
  title: getLanguage("数采器编码"),
  dataIndex: "config_code",
  align: "center",
},
{
  title: getLanguage("关联设备"), 
  dataIndex: "device_name",
  align: "center",
},
{
  title: getLanguage("数采器类型"), 
  dataIndex: "config_type_name",
  align: "center",
},
{
  title: getLanguage("数采器状态"), 
  dataIndex: "config_status",
  align: "center",
},
{
  title: getLanguage("数据延时"),
  dataIndex: "delay",
  align: "center",
},
// {
//   title: getLanguage("最后通讯时间"),
//   dataIndex: "config_last_online",
//   align: "center",
// },
// {
//   title: getLanguage("MAC"),
//   dataIndex: "config_desc",
//   align: "center",
// },
];

onMounted(() => {
  init()
})

const init = () => {
  getData()
}

const getData = async () => {
let config: any = {
      params: {
        factoryId:localStorage.getItem("factory_id"),
        take: 2000,
      },
      headers: {
          requestId: uuidv4(),
      },
  };
  let result = await request.get('/api/external/hardware/das/list',config)
  
  dataList.value = result.data.list || []
  console.log('dataList.value', dataList.value)
}



return (_ctx: any,_cache: any) => {
  const _component_a_table = _resolveComponent("a-table")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createVNode(_component_a_table, {
      bordered: "",
      columns: columns,
      "data-source": _unref(dataList),
      pagination: false,
      loading: loading.value,
      size: "small"
    }, {
      bodyCell: _withCtx(({ column, text, record }) => [
        (column.dataIndex === 'config_status')
          ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
              _createTextVNode(_toDisplayString(text === 0 ? _unref(getLanguage)('离线') : '') + " " + _toDisplayString(text === 1 ? _unref(getLanguage)('在线') : ''), 1)
            ], 64))
          : _createCommentVNode("", true),
        (column.dataIndex === 'delay')
          ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
              _createTextVNode(_toDisplayString(!text ? _unref(getLanguage)('正常') : _unref(getLanguage)('延迟')), 1)
            ], 64))
          : _createCommentVNode("", true)
      ]),
      _: 1
    }, 8, ["data-source", "loading"])
  ]))
}
}

})